export default {
  title1: 'Contact us via telephone or Email: ',
  contactPhone: 'Telephone: 0086512-6813-8573',
  contactMail: 'Email: fanhan@fanhantech.com',
  title2: 'Submit your email here and we will respond (for users with PC mailbox clients)',
  name: 'Name',
  mail: 'Email',
  phone: 'Telephone',
  message: 'Task description',
  send: 'Send via client',
  js: {
    name: 'Name',
    mail: 'Email',
    phone: 'Telephone',
    message: 'Task description',
    title: 'Customize task',
    rule: 'Please confirm that all information is filled'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/sendmail.js